import axiosInstance from "./AxiosInstance";

export function getExpensesApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/expenses?${fparam}`)
}

export function createExpenseApi(data){
    return axiosInstance.post('api/expenses',data)
}

export function updateExpenseApi(id,data){
    return axiosInstance.patch(`api/expenses/${id}`,data)
}

export function deleteExpenseApi(id){
    return axiosInstance.delete(`api/expenses/${id}`)
}

export function getExpenseExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/expenses?${fparam}`, {
    responseType: "blob",
  });
}

//expense=category

export function getExpenseCategoryApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/expense-categories?${fparam}`)
}

export function createExpenseCategoryApi(data){
    return axiosInstance.post('api/expense-categories',data)
}

export function updateExpenseCategoryApi(id,data){
    return axiosInstance.patch(`api/expense-categories/${id}`,data)
}

export function deleteExpenseCategoryApi(id,data){
    return axiosInstance.delete(`api/expense-categories/${id}`)
}

//expense-sub-category
export function getSubCategoryApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/expense-subcategories?${fparam}`)
}
export function createSubCategoryApi(data){
    return axiosInstance.post('api/expense-subcategories',data)
}
export function deleteSubCategoryApi(id){
    return axiosInstance.delete(`api/expense-subcategories/${id}`)
}
export function updateSubCategoryApi(id,data){
    return axiosInstance.put(`api/expense-subcategories/${id}`,data)
}